import styled from 'styled-components';
import PropTypes from 'prop-types';
import imageHelper from '@utils/imageHelper';
import Confetti from '../Confetti';
import {
  SuccessMessageTitle,
  SuccessMessageSubTitle,
  SuccessFulCover,
  SuccessFulContent,
  Download,
  DownloadCover,
  DownloadHeader,
  DownloadTitle,
  DownloadSubTitle,
  DownloadContent,
  PlayStoreIcon,
  AppImage,
  Divider
} from './styles';

const Flex = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

const SuccessFul = ({ success, type }) => {
  const { header, footer } = success;
  const isLeadGenForm = type === 'leadGen';
  return (
    <>
      <SuccessFulCover $isLeadGenForm={isLeadGenForm}>
        <SuccessFulContent $isLeadGenForm={isLeadGenForm}>
          <Confetti />
          <SuccessMessageTitle>{header.title}</SuccessMessageTitle>
          <SuccessMessageSubTitle>{header.description}</SuccessMessageSubTitle>
        </SuccessFulContent>
      </SuccessFulCover>
      <Download $isLeadGenForm={isLeadGenForm}>
        <Divider $isLeadGenForm={isLeadGenForm} />
        <DownloadCover $isLeadGenForm={isLeadGenForm}>
          <DownloadHeader>{footer.title}</DownloadHeader>
          <DownloadTitle>{footer.subtitle}</DownloadTitle>
          <DownloadSubTitle $isLeadGenForm={isLeadGenForm}>
            {footer.description}
          </DownloadSubTitle>
        </DownloadCover>
        <DownloadContent $isLeadGenForm={isLeadGenForm}>
          <AppImage src={imageHelper.getImage('leadGen/app.png')} alt="app" />
          <Flex>
            <PlayStoreIcon
              href="https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DLeadGen%26utm_medium%3DWebApp%26utm_campaign%3DLeadGen%26"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imageHelper.getImage('playStore_resized.svg')}
                alt="download"
                height="42"
                width="128"
              />
            </PlayStoreIcon>
            <PlayStoreIcon
              type="appleStore"
              $isLeadGenForm={isLeadGenForm}
              href="https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DLeadGen%26utm_medium%3DWebApp%26utm_campaign%3DLeadGen%26"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={imageHelper.getImage('appStore_resized.svg')}
                alt="download"
                height="42"
                width="128"
              />
            </PlayStoreIcon>
          </Flex>
        </DownloadContent>
      </Download>
    </>
  );
};

SuccessFul.propTypes = {
  success: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired
};

export default SuccessFul;
